//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "storeList",
    data() {
        return {
            pageSize: 15,
            currentPage: 1,
            totalCount: 0,
            list: []
        }
    },
    methods: {
        getPage() {
            var memberId = localStorage.getItem('MemberId');
            if (parseInt(memberId) > 0) {
                abp.ajax.get('/api/services/app/Shop/GetShopsByUserId?userId=' + parseInt(memberId)).then(res => {
                    this.list = [];
                    this.list.push(...res.data.result);
                    // this.totalCount = res.data.result.totalCount;
                })
            }
        },
        goToBusiness(item) {
            this.$router.push({path: '/business/' + item.id});
        }
    },
    created() {
        this.getPage()
    }
}
